import range from 'lodash/range';
import {twMerge} from '../../../common/twMerge';
import {IndicatorProps} from './IndicatorProps.interface';

export function Indicator({
  currentIndex,
  numberOfItem,
  gapPx = 8,
  className,
  onClickDot = () => {},
  ...props
}: IndicatorProps) {
  return (
    <div className={twMerge('flex justify-center', className)} {...props}>
      {range(0, numberOfItem).map(index => {
        return (
          <div
            key={index}
            style={{
              marginRight: gapPx,
            }}
            className={twMerge(
              'h-8pxr w-8pxr cursor-pointer rounded-full',
              currentIndex === index
                ? 'bg-theme-solid-100'
                : 'bg-theme-transparent-20'
            )}
            onClick={() => onClickDot(index)}
          />
        );
      })}
    </div>
  );
}
